/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export const SECTION_NAME_CSS = 'Set up the styles';
export const SECTION_NAME_DOCUMENTATION = 'Explore the documentation';
export const SECTION_NAME_DOWNLOAD_PROJECT = 'Download your project';
export const SECTION_NAME_DOWNLOAD_FILES = 'Download files';
export const SECTION_NAME_EDIT_IN_STACKBLITZ = 'Edit your project';
export const SECTION_NAME_EXPLORE = 'Explore the sample';
export const SECTION_NAME_FEEDBACK = 'Problems or feedback?';
export const SECTION_NAME_HTML_FILE = 'Create your HTML file';
export const SECTION_NAME_ANGULAR_TEMPLATE = 'Set up your Angular template';
export const SECTION_NAME_INSTALL = 'Install packages';
export const SECTION_NAME_JS = 'Set up your JavaScript';
export const SECTION_NAME_REACT_COMPONENT = 'Set up your React component';
export const SECTION_NAME_VUE_COMPONENT = 'Set up your Vue component';
export const SECTION_NAME_ANGULAR_COMPONENT = 'Set up your Angular component';
export const SECTION_NAME_ADD_CKBOX = 'Add CKBox';
export const SECTION_NAME_RUN = 'Run!';
export const SECTION_NAME_LICENSE = 'Create an account';
export const SECTION_NAME_LICENSE_OPTIONAL = 'Create an account (optional)';
export const SECTION_NAME_SETUP = 'Select your setup';
export const SECTION_NAME_WELCOME = 'Congrats!';
